import Model, { attr } from '@ember-data/model';

export default class AirbnbOfficialConnectionListingModel extends Model {
  @attr('string') name!: string;
  @attr('boolean') linked!: boolean;
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'airbnb-official-connection-listing': AirbnbOfficialConnectionListingModel;
  }
}
